module.exports = __webpack_public_path__ + "static/pronto-atendimento-04598a1a389f8687094b54c41f3458c4.jpg";